import React, { createContext, PropsWithChildren, useCallback, useContext, useMemo, useState } from 'react';

import { get } from '@eika-infrastruktur/request';

import { useBankregnr } from '../config';
import { getRequestOptions } from '../meldskade/reducer/skademelding-actions';
import { Skademeldingstype } from '../types/generated-types';
import { Kundeinfo } from '../types/internal-types';
import { hentUserUrl } from '../urler';

type KundeContext = {
    kundeinfo: Kundeinfo | undefined;
    getKundeinfo: (skadetype?: Skademeldingstype) => Promise<void>;
};

const Context = createContext<KundeContext | undefined>(undefined);

const KundeProvider: React.FC<PropsWithChildren> = ({ children }) => {
    const bankregnr = useBankregnr();
    const [kundeinfo, setKundeinfo] = useState<Kundeinfo>();

    const getKundeinfo = useCallback(
        async (skadetype: Skademeldingstype = undefined): Promise<void> =>
            get(hentUserUrl(skadetype), getRequestOptions(bankregnr)).then(setKundeinfo),
        [bankregnr],
    );
    const kundeContext: KundeContext = useMemo(() => ({ kundeinfo, getKundeinfo }), [kundeinfo, getKundeinfo]);

    return <Context.Provider value={kundeContext}> {children} </Context.Provider>;
};
const useKunde = (): KundeContext => {
    const context = useContext(Context);
    if (context === undefined) {
        throw new Error('useKunde must be used within a KundeProvider');
    }
    return context;
};

export { KundeProvider, useKunde };
